<template>
  <div class="discount-badge" v-if="discount_type != 'no_discount'">
    <div :id="id" class="badge badge-danger">
      {{badge_text}}
    </div>
    <b-tooltip v-if="tooltip" :target="id" :placement="position" triggers="hover" >
      {{tooltip_text}}
    </b-tooltip>
  </div>
</template>

<script>
export default {
  name: "DiscountBadge",
  props:{
    id_key: String,
    discount: Number,
    discount_type: String,
    currency_name: String,
    position: {
      type: String,
      default: 'top',
    },
    tooltip: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: '%',
    },
    smart: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed:{
    id() {
      return `${this.id_key}-discount-badge`
    },
    tooltip_text(){
      if (this.discount_type == 'fixed_value') {
        return `Скидка ${this.discount} р. с человека`
      } else {
        return `Скидка ${this.discount}%`
      }
    },
    smart_text(){
      if (this.discount_type == 'fixed_value') {
        return `-${this.discount}р/чел`
      } else {
        return `-${this.discount}%`
      }
    },
    badge_text(){
      if (this.smart) {
        return this.smart_text;
      } else {
        return this.text;
      }
    },
  },

}
</script>

<style scoped>
.discount-badge {
  position: absolute;
  top: -12px;
  right: -6px;
}

</style>